import { render, staticRenderFns } from "./vIngredientManagement.vue?vue&type=template&id=6327f92c&scoped=true"
import script from "./vIngredientManagement.vue?vue&type=script&lang=ts"
export * from "./vIngredientManagement.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientManagement.vue?vue&type=style&index=0&id=6327f92c&prod&lang=css"
import style1 from "./vIngredientManagement.vue?vue&type=style&index=1&id=6327f92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327f92c",
  null
  
)

export default component.exports